import {
  SearchEquipmentResponse,
  SearchEquipmentWorkerResponse,
} from '../../../../core/openapi/bff-admin-api';
import { getCorrectedEquipmentUptime } from '../../../../shared/helpers/uptime.helper';
import { IDevice, IDeviceWorker } from './device-list.model';

export class DeviceListMapper {
  public static mapFromDto(apiItem: SearchEquipmentResponse): IDevice {
    return {
      id: apiItem.id,
      modelName: apiItem.modelName,
      subModelName: apiItem.subModelName ?? null,
      firmwareFamily: apiItem.firmwareFamily,
      serialNumber: apiItem.serialNumber ?? null,
      ipAddress: apiItem.ipAddress,
      uptime: apiItem.uptime ?? undefined,
      correctedUptime:
        getCorrectedEquipmentUptime(apiItem.uptime, apiItem.collectedAt) ?? undefined,
      facilityName: apiItem.facilityName,
      macAddress: apiItem.macAddress,
      currentHashrate: apiItem.currentHashrate,
      hashrateUnitId: apiItem.hashrateUnitId,
      currentPower: apiItem.currentPower,
      fanSpeeds: apiItem.fanSpeeds,
      collectedAt: apiItem.collectedAt,
      telemetryFresh: apiItem.telemetryFresh,
      status: apiItem.status,
      mode: apiItem.mode,
      availableModes: apiItem.availableModes,
      faultSeverity: apiItem.faultSeverity,
      faultCount: apiItem.faultCount ?? null,
      workers: Array.isArray(apiItem.workers)
        ? apiItem.workers.map(
            (worker: SearchEquipmentWorkerResponse): IDeviceWorker => ({
              id: worker.id,
              name: worker.name,
              number: worker.number,
              isActive: worker.isActive,
            }),
          )
        : [],
    };
  }
}
